module.exports = __webpack_public_path__ + "static/calatonSystemsDesktop@2x-e987c511e54b4810ac9660276c31856a.jpg";